import { render, staticRenderFns } from "./Bank.vue?vue&type=template&id=b5057764&scoped=true"
import script from "./Bank.vue?vue&type=script&lang=js"
export * from "./Bank.vue?vue&type=script&lang=js"
import style0 from "./Bank.vue?vue&type=style&index=0&id=b5057764&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5057764",
  null
  
)

export default component.exports